import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import iconlogo from '../assets/iconLogo.png'
import { T } from '../Auth/Util';


function Header() {

  const [navOpen, setNavOpen] = useState(false);
  const history = useNavigate();

  const nav = (url,n) => {
      history(url);
      upTo(n)
      setNavOpen(false); 
  }



  const open = () => {
    console.log(`Page ${navOpen}`);
      upTo(0);
      if(!navOpen){
        setNavOpen(true)
      }else{
        setNavOpen(false)
      }
  }



  const upTo = (index) => {
    window.scrollTo({
     top: index,
     left: 0,
     behavior: 'smooth'      
    });
  }




  const chck = () => {
    localStorage.getItem(process.env.REACT_APP_LS) != null ? 
    history("/console")
      :
    history("/signin")
  }




  return <>
          {navOpen == true ? 
           <div className='z-50 w-full h-screen bg-[#060d1a]/100 flex'>
                  <div className='flex justify-center text-center align-middle flex-col w-full'>
                  
                      <nav class="flex flex-col justify-center text-left items-center gap-12 ">
                        <a class="text-gray-300 text-lg  lg:text-sm font-medium leading-normal hover:text-primary transition-colors" onClick={(e)=>nav("/", 2000)}>Features</a>
                        <a class="text-gray-300 text-lg  lg:text-sm  font-medium leading-normal hover:text-primary transition-colors" onClick={(e) => nav("/",3900)}>Products</a>
                        <a class="text-gray-300 text-lg  lg:text-sm  font-medium leading-normal hover:text-primary transition-colors" onClick={(e)=>nav("/contact",0)}>Contact us</a>  
                        <a class="text-gray-300 text-lg  lg:text-sm  font-medium leading-normal hover:text-primary transition-colors" onClick={(e)=>nav("/shop/0",0)}>Shop</a>
                      </nav>

                    {!window.location.href.includes("forgotpass") ?
                      <div class="self-center mt-10" >
                        <button onClick={chck} style={{backgroundColor:T.buttonColor}} class="flex min-w-[84px] cursor-pointer items-center justify-center rounded-lg h-10 px-4 bg-primary text-white text-sm font-bold leading-normal tracking-[0.015em] hover:opacity-90 transition-opacity">
                        <span class="truncate"  >Tracking Dashboard</span>
                        </button>
                      </div> 
                    :null} 
                  </div> 
                  
                 </div>
              : <h1></h1>}

            <div class="sticky flex flex-col overflow-x-hidden z-50">
              <nav class="fixed top-0 left-0 right-0 z-50 bg-[#060d1a]/90 backdrop-blur-md border-b border-white/5">
                <div class="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                  <a  class="flex items-center gap-2.5 font-display" onClick={(e)=>nav("/",0)}>
                    <div class="w-8 h-8 rounded-lg flex items-center justify-center" >
                        <img src={iconlogo}  />
                    </div>
                    <span class="text-white font-extrabold text-xl tracking-tight">Beeppee</span>
                  </a>
              
                <div  class="hidden md:flex items-center gap-7 font-body">
                  <a  class="text-white/70 text-sm hover:text-white transition-colors" onClick={(e)=>nav("/",1000)}>Features</a>
                  <a  class="text-white/70 text-sm hover:text-white transition-colors" onClick={(e) => nav("/",2300)}>Products</a>
                  <a  class="text-white/70 text-sm hover:text-white transition-colors" onClick={(e)=>nav("/shop/0",0)}>Shop</a>
                  <a  class="text-white/70 text-sm hover:text-white transition-colors" onClick={(e)=>nav("/contact",0)}>Contact us</a>
                  {!window.location.href.includes("forgotpass") ?
                  <a   class="animate-glowPulse bg-gradient-to-r from-[#1a6ef5] to-[#3b8dff] text-white text-sm font-semibold px-5 py-2.5 rounded-xl hover:opacity-90 transition-opacity font-display" onClick={chck}>
                    Tracking Dashboard
                  </a>
                   :null}
                </div>
               

                <button class="md:hidden text-white/70 hover:text-white" aria-label="Menu" onClick={open}>
                 {!navOpen ? <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path d="M4 6h16M4 12h16M4 18h16"/>
                    </svg> :  <span className='absolute h-10 top-0 mt-0 right-0 p-4 text-[30px] font-bold cursor-pointer text-white' onClick={(e) => setNavOpen(false)}>X</span>}
                </button>
              </div>
            </nav>
      </div>
      </>
  
}

export default Header